import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-spinner',
	template: `
		<div class="cssload-container" *ngIf="loader">
			<div class="cssload-speeding-wheel"></div>
		</div>
	`,
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
	@Input() loader: boolean = false;
}
